import WarehouseShopCategoryData, {
    IWarehouseShopCategoryData
} from "@/http/data/warehouse-shop-category-data";

import WarehouseShopProductData, {
    IWarehouseShopProductData
} from "@/http/data/warehouse-shop-product-data";

import WarehouseShopOrderData, {
    IWarehouseShopOrderData
} from "@/http/data/warehouse-shop-order-data";

export interface IWarehouseShopData {
    building: string;
    categories?: IWarehouseShopCategoryData[];
    products?: IWarehouseShopProductData[];
    current_order?: null|IWarehouseShopOrderData;
}

export default class WarehouseShopData {
    public building: string;
    public categories: WarehouseShopCategoryData[];
    public products: WarehouseShopProductData[];
    public current_order: null|WarehouseShopOrderData;

    constructor(data: IWarehouseShopData) {
        this.building = data.building;
        this.categories = (data.categories ?? []).map(
            category => new WarehouseShopCategoryData(category)
        );
        this.products = (data.products ?? []).map(
            product => new WarehouseShopProductData(product)
        );
        this.current_order = data.current_order
            ? new WarehouseShopOrderData(data.current_order)
            : null;
    }
}